<template>
  <Dialog :open="isOpen" @close="$emit('close')">
    <div class="tw-fixed tw-inset-0 tw-bg-black/80 tw-z-[10000]" aria-hidden="true" />
    <div class="tw-fixed tw-inset-0 tw-flex tw-w-screen tw-items-center tw-justify-center tw-z-[10000]">
      <DialogPanel class="tw-w-full tw-h-[100vh]  tw-flex tw-items-center">
        <!--  tw-relative -->
        <div class="tw-absolute tw-right-[15px] tw-top-[15px] tw-justify-end tw-z-[2000] hamburger">
          <div class="tw-flex tw-items-center tw-cursor-pointer" @click="$emit('close')">
            <button ref="closeButton" type="button" class="focus:tw-outline-none tw-border-none tw-bg-transparent tw-p-0" aria-label="Close" id="image-zoom-close">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#fff" class="tw-size-[45px]">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
              </svg>

            </button>
          </div>
        </div>

        <swiper
          :modules="modules"
          :style="{
            '--swiper-navigation-color': '#fff',
            '--swiper-pagination-color': '#fff',
            '--swiper-navigation-size': '54px',
            '--swiper-navigation-sides-offset': '15px',
          }"
          :navigation="true"
          :initialSlide="startingIndex"
          >
          <swiper-slide v-for="image in images" :key="image.id">

            <!-- <div class=""> -->
              <img :src="image.src" class="tw-mx-auto"/>
              <p class="tw-pt-1 tw-text-center tw-text-white">
                <span>{{ image.caption }}</span>
              </p>
            <!-- </div> -->
          </swiper-slide>
        </swiper>
      </DialogPanel>
    </div>
  </Dialog>
</template>

<script setup>
import { Dialog, DialogPanel } from "@headlessui/vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const modules = [Navigation];

const props = defineProps({
  images: {
    type: Array,
    required: true,
  },
  isOpen: {
    type: Boolean,
    required: true,
  },
  startingIndex: {
    type: Number,
    default: 0,
  },
});
</script>

